/**
 * Componente que se encarga de recibir las peticiones enviadas desde el componente
 * de ubicaciones en el momento de crear, editar o eliminar los registros.  
 * Esto con el fin de que se recarguen los datos de las tablas afectadas por las datatables.
 * JMM-2018-04-25
 */

//Componente
import { Component, OnInit } from '@angular/core';
//Enrutamiento
import { Router, ActivatedRoute } from '@angular/router';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';

@Component({
  selector: 'app-enrutamientoubicaciones',
  templateUrl: './enrutamientoubicaciones.component.html'
})
export class EnrutamientoubicacionesComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http:Http
  ) {}

  ngOnInit() 
  {
    let ubicacion = this.route.snapshot.paramMap.get('ub');
    let idpais = this.route.snapshot.paramMap.get('idpais');
    let iddpto = this.route.snapshot.paramMap.get('iddpto');
    let idciudad = this.route.snapshot.paramMap.get('idciudad');
    let idbarrio = this.route.snapshot.paramMap.get('idbarrio');
    
    //Pais
    if (ubicacion == 'ubicacion_pais') {
      this.router.navigate(['/main/ubicaciones/',ubicacion,0,0,0,0], { replaceUrl: true });
    }

    //Dpto
    if (ubicacion == 'ubicacion_dpto' && idpais != '0') {
      this.router.navigate(['/main/ubicaciones/',ubicacion,idpais,0,0,0], { replaceUrl: true });
    }

    //Ciudad
    if (ubicacion == 'ubicacion_ciudad' && idpais != '0' && iddpto != '0') {
      this.router.navigate(['/main/ubicaciones/',ubicacion,idpais,iddpto,0,0], { replaceUrl: true });
    }

    //Barrio
    if (ubicacion == 'ubicacion_barrio' && idpais != '0' && iddpto != '0' && idciudad != '0') {
      this.router.navigate(['/main/ubicaciones/',ubicacion,idpais,iddpto,idciudad,0], { replaceUrl: true });
    }

  }// .ngOnInit() 

}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/main/enrutamientos/enrutamientoubicaciones/enrutamientoubicaciones.component.ts